// 组件全局注册
import Vue from 'vue';



//web端评论组件
import SHPraise from './praise/index.js'
Vue.use(SHPraise);

//web端评论组件
import SHWEBComment from './comment/web/index.js'
Vue.use(SHWEBComment);


//web端评论组件
import SHWEBCommentChild from './comment/web/child/index.js'
Vue.use(SHWEBCommentChild);



// WEBPACK FOOTER //
// ./src/components/base/view/interact/cmps/cmps.js